import React from 'react';
import { style } from 'typestyle';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { poolTableHeadersLine } from '../dataConnectMultiPool/DataConnectMultiPoolTableHeaders';

export type DataConnectPoolNodesSectionHeadersProps = Readonly<{
  isDefaultPool: boolean;
}>

export function DataConnectPoolNodesSectionHeaders(props: DataConnectPoolNodesSectionHeadersProps) {
  const tooltipPath = imgPath('info_normal.svg');
  let rowClass = 'tb-data-grid-headers-line';
  rowClass = poolTableHeadersLine;

  return <>
    <tbody>
      <tr>
        <th className={`${rowClass} ${tableCell300Width}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-node-hostname-column-header'}>
            {Messages.dataConnectSiteSettingsPoolNodeHostnameColumnName()}
          </span>
        </th>
        <th className={`${rowClass} ${tableCell200Width}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-node-ip-column-header'}>
            {Messages.dataConnectSiteSettingsPoolNodeIPColumnName()}
          </span>
        </th>
        <th className={`${rowClass} ${tableCell200Width}`}>
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-node-status-column-header'}>
            {Messages.dataConnectSiteSettingsPoolNodeStatuscolumnName()}
          </span>
        </th>
        <th className={rowClass} data-tb-test-id={'pool-node-actions-column-header'} >
          <span className={'tb-data-grid-header-text'} data-tb-test-id={'pool-node-actions-column-header'}>
            {Messages.dataConnectSiteSettingsPoolActionsColumnName()}
          </span>
        </th>
      </tr>
    </tbody>
  </>;
}


const tableCell300Width = style({
  width: '300px'
});
const tableCell200Width = style({
  width: '200px'
});
